import React from "react";
import { Link } from "react-router-dom";

export const ErrorPage = () => {
  return (
    <>
        <div class="flex flex-col h-screen justify-center items-center">
          <h1 class="text-[120px] font-extrabold text-white">404</h1>
          <p class="text-2xl font-medium text-white mb-6">Page Not Found</p>
          
            <Link to="/" class="px-4 py-2 font-medium text-white bg-gray-500 rounded-md hover:bg-gray-600 transition-all duration-200 ease-in-out"
          >
            Go Home
          </Link>
        </div>
    </>
  );
};
